import React, { useMemo, useState, useEffect, useCallback, useReducer } from 'react';
import {
	TranslatedString,
	LocallySortedAndPaginatedTable,
	makeLocallySortedAndPaginatedTableColumnHeader,
	useAjax,
	XhrStatus,
	Card
} from '@bosch/bt-ui';
import './WebConnectMetricsPage.css';
import withErrorHandler from '../../components/ErrorHandler';
import RestfulCallout from '../../components/RestfulCallout';
import RestfulCallLoading from '../../components/RestfulCallLoading';
import ContentDialog from '../../components/ContentDialog';

const TABLE_HEADERS = [
	makeLocallySortedAndPaginatedTableColumnHeader('ContainerName', 'Container Name'),
	makeLocallySortedAndPaginatedTableColumnHeader('ConnectionCount', 'Connection Count'),
	makeLocallySortedAndPaginatedTableColumnHeader('CPUUsage', 'CPU Usage'),
	makeLocallySortedAndPaginatedTableColumnHeader('MemoryUsage', 'Memory Usage'),
	makeLocallySortedAndPaginatedTableColumnHeader('UpdateDate', 'Update Date')
];

const METRICA_DETAIL_TABLE_HEADERS = [
	makeLocallySortedAndPaginatedTableColumnHeader('CloudId', 'CloudId'),
	makeLocallySortedAndPaginatedTableColumnHeader('Host', 'Host'),
	makeLocallySortedAndPaginatedTableColumnHeader('Port', 'Port'),
	// makeLocallySortedAndPaginatedTableColumnHeader('ConnectorId', 'ConnectorId'),
	makeLocallySortedAndPaginatedTableColumnHeader('ICCID', 'ICCID'),
	makeLocallySortedAndPaginatedTableColumnHeader('ConnectedTime', 'Connected Time'),
	makeLocallySortedAndPaginatedTableColumnHeader('LastSendDataTime', 'Last Send Time'),
	makeLocallySortedAndPaginatedTableColumnHeader('LastReceivedTime', 'Last Received Time'),
	makeLocallySortedAndPaginatedTableColumnHeader('LastReceivedStatus', 'Last Received Status'),
	makeLocallySortedAndPaginatedTableColumnHeader('TransactionID', 'TransactionID'),
];

function getData(getWCMetrics, token) {
	getWCMetrics('GET', SUPPORTCONSOLE_API_URL + '/api/wcmetrics/v1/metrics/getall', undefined, undefined, { 'Authorization': 'Bearer ' + token.token });
}

const WebConnectMetricsPage = (props) => {
	const {
		token,
	} = props;

	const [currentPage, setCurrentPage] = useState(1);
	const [openDialog, setOpenDialog] = useState(false);
	const [detailRows, setDetailRows] = useState();
	const [result, status, getWCMetrics, response] = useAjax(XhrStatus.InProgress);

	useEffect(
		() => {
			// If useAjax(XhrStatus.InProgress) and not login yet, it will show 401
			// So we need to make sure token is avaliable to continue...
			if (token?.token) {
				getData(getWCMetrics, token);
			}
		},
		[getWCMetrics, token]
	);

	function makeRow(task) {
		const {
			containerName,
			connectionCount,
			metricsDetails,
			cpuUsage,
			memoryUsage,
			updateDate
		} = task;

		return {
			key: containerName,
			columns: [
				{
					key: 'ContainerName',
					columnContent: containerName
				},
				{
					key: 'ConnectionCount',
					columnContent: connectionCount
				},
				{
					key: 'CPUUsage',
					columnContent: cpuUsage + ' %'
				},
				{
					key: 'MemoryUsage',
					columnContent: memoryUsage + ' MB'
				},
				{
					key: 'UpdateDate',
					columnContent: DatetimeFormatConverter(updateDate)
				}
			],
			htmlAttributes: {
				onClick: () => metricaDetail(metricsDetails)
			},
			subRows: undefined
		};
	}

	const rows = useMemo(
		() => {
			console.log(result);
			const Rows = (result?.data) ? result.data.map(item => makeRow(item)) : [];
			return Rows;
		},
		[result]
	);

function DatetimeFormatConverter(dateTime) {
		if (!dateTime) {
			return '';
		}

		const trimmedDate = dateTime.trim();
		const withTimeDelimiter = trimmedDate.includes('T')
			? trimmedDate
			: trimmedDate.replace(' ', 'T');

		const hasTimeZoneSuffix = /([+-]\d{2}:\d{2}|Z)$/i.test(withTimeDelimiter);
		const isoDate = hasTimeZoneSuffix ? withTimeDelimiter : `${withTimeDelimiter}Z`;

		const localDate = new Date(isoDate);
		if (Number.isNaN(localDate.getTime())) {
			return trimmedDate;
		}

		const year = localDate.getFullYear();
		const month = String(localDate.getMonth() + 1).padStart(2, '0');
		const day = String(localDate.getDate()).padStart(2, '0');
		const hours = String(localDate.getHours()).padStart(2, '0');
		const minutes = String(localDate.getMinutes()).padStart(2, '0');
		const localDateTime = `${year}/${month}/${day} ${hours}:${minutes}`;
		return localDateTime;
	}

	function metricaDetail(datas) {
		const rows = datas.map(data => {
			const {
				transactionId,
				connectionId,
				connectedTime,
				lastReceivedTime,
				lastSendDataTime,
				lastReceivedStatus,
				cloud,
				ethernet
			} = data;
			return {
				key: connectionId,
				columns: [
					{
						key: 'CloudId',
						columnContent: cloud != null ? cloud.cloudId : null
					},
					{
						key: 'Host',
						columnContent: ethernet != null ? ethernet.ipAddress : null
					},
					{
						key: 'Port',
						columnContent: ethernet != null ? ethernet.portNumber : null
					},
					// {
					// 	key: 'ConnectorId',
					// 	columnContent: ethernet != null ? ethernet.connectorId : null
					// },
					{
						key: 'ICCID',
						columnContent: ethernet != null ? ethernet.iccid : null
					},
					{
						key: 'ConnectedTime',
						columnContent: DatetimeFormatConverter(connectedTime)
					},
					{
						key: 'LastSendDataTime',
						columnContent: DatetimeFormatConverter(lastSendDataTime)
					},
					{
						key: 'LastReceivedTime',
						columnContent: DatetimeFormatConverter(lastReceivedTime)
					},
					{
						key: 'lastReceivedStatus',
						columnContent: lastReceivedStatus
					},
					{
						key: 'TransactionID',
						columnContent: transactionId
					}
				],
				htmlAttributes: undefined,
				subRows: undefined
			}
		})

		setDetailRows(rows);
		setOpenDialog(true);
	}

	return (
		<Card
			htmlAttributes={{
				id: 'wc-metrics-page'
			}}
		>
			<RestfulCallout status={status} response={response} returnObj={result} hideSuccess={true} />
			{
				<LocallySortedAndPaginatedTable
					headers={TABLE_HEADERS}
					rows={rows}
					numRowsPerPage={100}
					currentPage={currentPage}
					goToPageFunc={setCurrentPage}
					htmlAttributes={{
						className: 'wc-metrics-table'
					}}
					errorMessage="Error occured"
					noResultsMessage={<TranslatedString stringId="No Metrics Data found" />}
				/>
			}
			{
				<ContentDialog
					openDialog={openDialog}
					setOpenDialog={setOpenDialog}
					tableHeaders={METRICA_DETAIL_TABLE_HEADERS}
					tableRows={detailRows}
					numRowsPerPage={50}
				/>
			}
			<RestfulCallLoading status={status} />
		</Card>
	);
};

export default withErrorHandler(React.memo(WebConnectMetricsPage));
